import $ from 'jquery';
import axios from 'axios';

$.fn.replaceWithPush = function (a) {
  const $a = $(a);

  this.replaceWith($a);
  return $a;
};

let guid = 0;
function guidGenerator() {
  return `pdf-embed-${++guid}`;
  // const S4 = function () {
  //   return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  // };
  // return `${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
}

const pdfWatchLoader = (pdf) => {
  // add loading class
  $(pdf)
    .parents('.pdf-embed-wrapper')
    .addClass('loading');

  const url = $(pdf).data('url');
  const ID = guidGenerator();
  const src = `https://docs.google.com/viewer?url=${url}&embedded=true`;
  const iframe = $('<iframe>', {
    src: `/pdf-viewer?src=${encodeURIComponent(src)}&ID=${ID}`,
    frameborder: '0',
    id: ID,
  });

  let watch;

  const ready = () => {
    clearInterval(watch);
    console.log(`Loaded: ${url}`);
  };

  const timeToCheck = 6000;
  // watch = setInterval(() => {
  //   console.log(`Reloading: ${url}`);
  //   $(`#${ID}`)
  //     .replaceWith(iframe)
  //     .on('load', ready);
  // }, timeToCheck);

  console.log(`Creating ${ID}`);
  $(pdf).replaceWithPush(iframe);
};

const loadPDFs = () => {
  // <iframe src="https://docs.google.com/viewer?url=' . $args['url'] . '&embedded=true" frameborder="0"></iframe>
  const pdfs = [];

  // figure out where pdfs are in doc
  $('.custom-pdf-loader').each((index, pdf) => {
    pdfs.push({ pdf, top: $(pdf).offset().top });
  });

  // figure out where you are in document
  const userScrollPosition = $(window).scrollTop();

  // sort based on distance from user scroll
  pdfs.sort((a, b) => Math.abs(a.top - userScrollPosition) - Math.abs(b.top - userScrollPosition));

  // pdfs.forEach((pdf, index) => {
  //   $(pdf.pdf).text(`Number ${index}`);
  // });

  pdfs.forEach((pdf, index) => {
    setTimeout(() => {
      pdfWatchLoader(pdf.pdf);
    }, index * 250);
  });
};

export default loadPDFs;
